import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, FieldArray } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';
import { closeDrawer } from '../vouchersActions';
import renderItem from './renderItem';
import submit from './submit';

const useStyles = makeStyles(() => ({
  drawerPaper: {
    borderRadius: '15px 0px 0px 0px',
    width: '41vw',
    overflowX: 'hidden'
  }
}));

let ItemsForm = ({ handleSubmit, currentReturnVoucher }) => {
  const classes = useStyles();
  return (
    <form className={classes.form} onSubmit={handleSubmit} noValidate>
      <FieldArray
        name="items"
        component={renderItem}
        currentReturnVoucher={currentReturnVoucher}
      />
    </form>
  );
};

const mapStateToProps = state => {
  const { items } = state.vouchers.currentReturnVoucher;
  return {
    currentReturnVoucher: state.vouchers.currentReturnVoucher,
    initialValues: {
      items
    }
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchCloseDrawer: () => dispatch(closeDrawer())
});

ItemsForm.propTypes = {
  handleSubmit: PropTypes.func,
  currentReturnVoucher: PropTypes.object
};

ItemsForm = reduxForm({
  form: 'updateRecipientReturnVoucher',
  forceUnregisterOnUnmount: true,
  onSubmit: submit
})(ItemsForm);

export default connect(mapStateToProps, mapDispatchToProps)(ItemsForm);
